import {
  RESET_CUSTOMER_METADATA_ISFETCHING,
  CUSTOMER_METADATA_LIST_REQUESTING,
  LIST_CUSTOMER_METADATA_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  isListFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CUSTOMER_METADATA_ISFETCHING: {
      return {
        ...state,
        isListFetching: false
      };
    }
    case CUSTOMER_METADATA_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case LIST_CUSTOMER_METADATA_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.data.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        data,
        query,
        recordCount: action.payload.total,
        isListFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
